import { useMemo } from 'react';
import { Box } from '~/commonComponents/Box';
import { Column } from '~/commonComponents/Column';
import { EmptyScreen } from '~/commonComponents/EmptyScreen/EmptyScreen';
import { Text } from '~/commonComponents/Text';
import { EmptyRecommendedProsIcon } from '~/images/emptyScreenIcons';
import { Colors } from '~/themes/colors';
import { ProfessionalList } from '../ProfessionalList';
import { IProfessionalTabPanelProps } from '../types';
import { IRecommendedProfessional, IUser } from '~/models';

export const RecommendedProsTabPanel = ({
  isInviting,
  isLoading,
  selectedProfessionals,
  onClosePopup,
  onSelectProfessionals,
  onSentInvitations,
  isSelectionMode,
  profession,
  data = [],
}: IProfessionalTabPanelProps<IRecommendedProfessional>) => {
  const professionals = useMemo(() => {
    return data?.map(
      (it) =>
        ({
          full_name: it.fullname,
          id: it.id,
          isAvailable: true,
          profile_image: it.profile_image,
          professions: it.professions,
        }) as IUser & { professions: string[] },
    );
  }, [data]);

  const isEmpty = !isLoading && professionals.length === 0;

  return (
    <Column flex={1}>
      {!isEmpty && !isLoading && (
        <Text textAlign="center" italic color={Colors.neutral_500}>
          Reliable professionals, trusted by nearby offices. They&apos;ll be confirmed if they
          accept your offer as posted.
        </Text>
      )}

      <Box flex={1}>
        <ProfessionalList
          EmptyComponent={
            <EmptyScreen
              Icon={EmptyRecommendedProsIcon}
              width={420}
              style={{ alignItems: 'center' }}
              title="No new professionals at this time!"
              description="We are searching for professionals who meet the “New to You” criteria in your
                  area. Come back soon to see who we find!"
            />
          }
          isEmpty={isEmpty}
          isInviting={isInviting}
          isLoading={isLoading}
          professionals={professionals}
          selectedProfessionals={selectedProfessionals}
          selectedProfession={profession}
          onClose={onClosePopup}
          onSelectProfessionals={onSelectProfessionals}
          onSentInvitations={onSentInvitations}
          confirmButtonText={isSelectionMode ? 'Confirm' : undefined}
        />
      </Box>
    </Column>
  );
};
